import React from 'react';

import { CollapsibleSection } from 'cpool-components/general/CollapsibleSection';
import type { SchemaConditions } from 'cpool-schemas';

import { SectionHeader } from '~/features/leadDetails/components/BankCreditRequest/OfferHistory/HistorySection/SectionHeader';

type Props = {
    children: React.ReactNode;
    conditions: SchemaConditions;
    offerCount: number;
    requestedAt: string;
    hasSecondApplicant: boolean;
    defaultOpen?: boolean;
};

export const HistorySection: React.FC<Props> = ({
    children,
    conditions,
    defaultOpen = false,
    hasSecondApplicant,
    offerCount,
    requestedAt,
}) => (
    <CollapsibleSection
        title={
            <SectionHeader
                hasSecondApplicant={hasSecondApplicant}
                conditions={conditions}
                offerCount={offerCount}
                requestedAt={requestedAt}
            />
        }
        defaultOpen={defaultOpen}
        titleClassNames="font-normal"
        bgClassNames="bg-white rounded-lg border-l-2 border-blue px-4 py-3"
        panelClassNames="pt-3"
        testId="offer-history-section"
    >
        {children}
    </CollapsibleSection>
);
